import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoginDiv } from 'stash/components/log-in/LogInComponents';
import ResetPasswordExpired from 'stash/components/reset-password/ResetPasswordExpired';
import { NoAuthNavBar } from 'stash/components/global/NoAuthNavBar';
import { patchResetPassword } from '../../actions/api/user';
import { selectNudataWidgetData, selectQueryParams } from 'stash/selectors';
import {
	checkForgotPasswordValidity,
	postForgotPassword,
} from 'stash/actions/api/auth';
import { push } from 'connected-react-router';

import ResetPasswordForm from './ResetPasswordForm';

const mapDispatchToProps = (dispatch, ownProps) => ({
	resetPassword: ({ password }, session = {}, placement = {}) => {
		const widgetData = selectNudataWidgetData();

		return dispatch(
			patchResetPassword({
				user: {
					password: password,
					token: selectQueryParams(ownProps).token,
				},
				nudata: {
					placement,
					session,
					widgetData,
				},
			})
		)
			.then((res) => dispatch(push('/reset-password/success')))
			.catch((res) => {
				throw new Error(res.errors);
			});
	},
	checkForgotPasswordValidity: () => {
		return dispatch(
			checkForgotPasswordValidity(selectQueryParams(ownProps).token)
		);
	},
	sendEmail: ({ email }) => {
		return dispatch(postForgotPassword({ email }))
			.then(() => {
				dispatch(push('/forgot-password/check-email'));
			})
			.catch((res) => {
				throw new Error(res.errors);
			});
	},
});

const ResetPassword = ({
	resetPassword,
	checkForgotPasswordValidity,
	children,
	sendEmail,
}) => {
	const [isExpired, setIsExpired] = useState(false);
	const [checkCompleted, setCheckCompleted] = useState(false);
	useEffect(() => {
		checkForgotPasswordValidity()
			.then(() => {
				setIsExpired(false);
				setCheckCompleted(true);
			})
			.catch(() => {
				setIsExpired(true);
				setCheckCompleted(true);
			});
	}, [checkForgotPasswordValidity]);
	return (
		<div>
			<NoAuthNavBar />
			{checkCompleted && (
				<LoginDiv>
					{isExpired ? (
						<ResetPasswordExpired onSubmit={sendEmail} />
					) : (
						<ResetPasswordForm onSubmit={resetPassword} />
					)}
					{children}
				</LoginDiv>
			)}
		</div>
	);
};

export default connect(null, mapDispatchToProps)(ResetPassword);
